import { render, staticRenderFns } from "./BlogFeed.vue?vue&type=template&id=780d8d8e&"
import script from "./BlogFeed.vue?vue&type=script&lang=ts&"
export * from "./BlogFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports